
import FetchHandler from '../../../../assets/js/assets/FetchHandler'
import AlertHandler from '../../../../assets/js/modules/alertHandler';

export async function accountsSettings(event) {
    event.preventDefault();
    try {
        const { status, body } = await FetchHandler.sendFormData(event.target,{
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
        });
        if (status === 200 && body.success) {
            AlertHandler.showAlert(body.message, 'success');
            console.log(body.success_url)
            if(body.success_url) window.location.href = body.success_url
        } else {
            AlertHandler.showAlert(body.errors || 'Ein Fehler ist aufgetreten', 'danger');
        }
    } catch (error) {
        console.error('Caught error:', error);
        AlertHandler.showAlert('Ein Fehler ist aufgetreten: ' + error, 'danger');
    }
}